export {default as StepHeirs} from './1-StepHeirs';
export {default as StepPatrimony} from './2-StepPatrimony';
export {default as StepLifeInsurance} from './3-StepLifeInsurance';
